<template>
  <v-container grid-list-md>
    <v-card class="rounded-t" tile fluid>
      <v-card-title class="pa-4 primary white--text">
        <v-container class="pb-1">
          <h2>{{ currentArticle.title }}</h2>
          <v-breadcrumbs :key="$route.params.pathMatch" dark class="pa-0" :items="breadcrumbs">
            <slot name="item">
              <font-awesome-icon :icon="['fas', 'home']" class="mr-3 breadcrumb-home-icon" :class="{'mt-2 mb-2': breadcrumbs.length === 0}" @click="routeTo()"/>
              <span v-for="(crumb, i) in breadcrumbs" :key="i">
                <li class="v-breadcrumbs__divider">/</li>
                <li @click="routeTo(crumb.to)" class="breadcrumb-link" :class="{'breadcrumb-link-disabled': i === breadcrumbs.length - 1}">
                  {{crumb.text}}
                </li>
              </span>
            </slot>
          </v-breadcrumbs>
        </v-container>
      </v-card-title>
    </v-card>

    <v-row>
      <v-col class="pt-0 col-sm-12 col-md-9 col-lg-9" :class="$vuetify.breakpoint.mdAndUp ? 'pr-0' : 'pb-0'" style="z-index: 1">
        <v-card tile fluid id="print-content" class="markdown-content pa-5 fill-height" :class="$vuetify.breakpoint.mdAndUp ? 'rounded-bl' : ''">
          <!-- table for print footer -->
          <table>
          <tbody style="cursor: default;">
            <tr><td>
              <ArticleContent/>
            </td></tr>
          </tbody>
          <tfoot class="print-only" style="margin:0px 50px 0px 200px; color: #C8C8C8; position: fixed; bottom: 0; font-size:10px; font-family: Avenir, Helvetica, Arial, sans-serif;">
            <tr><td>
              Last updated by {{currentArticle.lastAction.user}} on {{new Date(currentArticle.lastAction.date).toLocaleString('en-US', dateOptions)}}
            </td></tr>
          </tfoot>
        </table>
        </v-card>
      </v-col>
      <v-col class="col-sm-12 col-md-3 col-lg-3 pt-0" :class="$vuetify.breakpoint.mdAndUp ? 'pl-0' : ''">
        <sidebar :editable="editable" class="fill-height">
          <viewer :key="currentArticle.contentSidebar" :initialValue="currentArticle.contentSidebar"/>
        </sidebar>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import { Viewer } from '@toast-ui/vue-editor'
import 'highlight.js/styles/github.css'
import Sidebar from './Sidebar'
import ArticleContent from './ArticleContent'
import { mapState } from 'vuex'
export default {
  components: {
    Viewer,
    Sidebar,
    ArticleContent
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dateOptions: { year: '2-digit', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short', timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }
  }),
  methods: {
    routeTo (uri = `/wiki/${process.env.VUE_APP_HOME_URI}`) {
      this.$router.push(uri)
    }
  },
  computed: {
    ...mapState('article', {
      currentArticle: state => state.currentArticle
    }),
    breadcrumbs () {
      const pathArr = decodeURIComponent(this.currentArticle.uri).split('/')
      if (pathArr[0] === process.env.VUE_APP_HOME_URI) { pathArr.shift() }
      const arr = []
      for (let i = pathArr.length; i > 0; i--) {
        let url = ''
        for (let j = 0; j < i; j++) {
          url += pathArr[j] + '/'
        }
        arr.push(url.slice(0, -1))
      }
      return arr.reverse().map(item => {
        const text = item.split('/')
        return {
          to: `/wiki/${item}`,
          text: text.slice(-1)[0].replaceAll('-', ' ').replaceAll('_', ' ')
        }
      })
    }
  },
  mounted () {
    document
      .querySelector('.markdown-content')
      .addEventListener('click', event => {
        if (event.target.nodeName === 'A') {
          if (event.target.attributes.href.value.indexOf(':') === -1) {
            event.preventDefault()
            this.$router.push(`/wiki/${event.target.attributes.href.value}`)
          }
        }
      })
  },
  beforeRouteUpdate (to, from, next) {
    this.$store
      .dispatch('article/transactions/getArticleAction', to.params.pathMatch)
      .then(() => next())
  }
}
</script>

<style scoped>
.breadcrumb-link {
  font-size: 20px;
  color:white;
  cursor: pointer;
  /* opacity: 0.5; */
}
.breadcrumb-link-disabled {
  cursor: default;
  opacity: 1;
}
.breadcrumb-home-icon {
  cursor: pointer;
  /* opacity: 0.5; */
}
.fill-height {
  height: 100%;
}
.breadcrumbs {
  padding: 0 0 0 0 !important;
}
a.v-breadcrumbs__item{
  color: #EEE !important;
}
ul.v-breadcrumbs.theme--dark > li > a.v-breadcrumbs__item.v-breadcrumbs__item--disabled {
  opacity: 0.5 !important;
  cursor: default;
}
.v-breadcrumbs__divider {
  cursor: default;
}
.v-card__text, .v-card__title {
  word-break: normal;
}
.print-only {
  display: none;
}
@media print {
  .print-only {
    display: default;
  }
}
</style>
